// Don't do anything, lean on AngularFire's DI init
